import { SOUNDS } from "assets/sounds";
import { SocketsContext } from "libs/soket";
import { useContext, useEffect, useState } from "react";

import { PlacedOrdersCountEventData } from "../siteBarCounters.types";

export const usePlacedOrdersAndReturnsCounter = () => {
  const { orderSocket } = useContext(SocketsContext);

  const [placedOrdersCount, setPlacedOrdersCount] = useState<number>(0);
  const [requestedOrderReturnsCount, setRequestedOrderReturnsCount] =
    useState<number>(0);

  useEffect(() => {
    if (orderSocket.socket) {
      orderSocket.socket?.on("counts", (data: PlacedOrdersCountEventData) => {
        if (data.countOfPlacedOrders) {
          setPlacedOrdersCount(data.countOfPlacedOrders);
        }
        if (data.placedOrdersCount === "Incremented") {
          setPlacedOrdersCount((prev) => prev + 1);
          SOUNDS.PLACED_ORDER.play();
        }
        if (data.placedOrdersCount === "Decremented") {
          setPlacedOrdersCount((prev) => prev - 1);
        }

        if (data.countOfRequestedOrderReturns) {
          setRequestedOrderReturnsCount(data.countOfRequestedOrderReturns);
        }
        if (data.requestedOrderReturnsCount === "Incremented") {
          setRequestedOrderReturnsCount((prev) => prev + 1);
          SOUNDS.RETURN_REQUESTED.play();
        }
        if (data.requestedOrderReturnsCount === "Decremented") {
          setRequestedOrderReturnsCount((prev) => prev - 1);
        }
      });
    }

    return () => {
      orderSocket?.socket?.off("counts");
    };
  }, [orderSocket.socket]);

  return { placedOrdersCount, requestedOrderReturnsCount };
};
